<template>
  <div v-if="all">
    <v-row>
      <v-col cols="12" sm="3">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="monthLabel"
              label="Mês"
              prepend-inner-icon="mdi-calendar"
              readonly
              solo
              dense
              hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="selectedMonth"
            type="month"
            no-title
            locale="pt-br"
            @input="onMonthSelected"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="5">
        <v-text-field
          label="Nome"
          solo
          v-model="query"
          append-icon="mdi-magnify"
          clearable
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" class="d-flex align-center flex-wrap" style="gap: 8px">
        <v-chip color="info" outlined>
          <v-icon left small>mdi-account-multiple</v-icon>
          {{ filtered.length }} no total
        </v-chip>
        <v-chip color="success" outlined>
          <v-icon left small>mdi-web</v-icon>
          {{ countSite }} site
        </v-chip>
        <v-chip color="warning" outlined>
          <v-icon left small>mdi-account-arrow-right</v-icon>
          {{ countIndicacao }} indicação
        </v-chip>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Celular</th>
          <th>Endereço</th>
          <th>Cidade</th>
          <th>Data</th>
          <th>Origem</th>
          <th>Indicação</th>
          <th>Pipefy</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in filtered" :key="item.id">
          <td>{{ item.name }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.address }}</td>
          <td>{{ item.city }}</td>
          <td>{{ formatDate(item.created) }}</td>
          <td>{{ originLabel(item.origin) }}</td>
          <td>{{ item.indicacao || "—" }}</td>
          <td>
            <a
              v-if="item.pipefyCardId"
              :href="'https://app.pipefy.com/open-cards/' + item.pipefyCardId"
              target="_blank"
              rel="noopener noreferrer"
              >{{ item.pipefyCardId }}</a
            >
            <span v-else>—</span>
          </td>
          <td>
            <v-btn icon @click="details(item)"
              ><v-icon>mdi-magnify</v-icon></v-btn
            >
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_details" width="500">
      <v-card>
        <v-card-title>
          {{ selected.name }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog_details = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>ID #{{ selected.id }}</v-card-subtitle>
        <v-divider></v-divider>
        <v-simple-table>
          <tbody>
            <tr>
              <th class="text-left">Celular</th>
              <td>{{ selected.phone || "—" }}</td>
            </tr>
            <tr>
              <th class="text-left">Endereço</th>
              <td>{{ selected.address || "—" }}</td>
            </tr>
            <tr>
              <th class="text-left">Cidade</th>
              <td>{{ selected.city || "—" }}</td>
            </tr>
            <tr>
              <th class="text-left">Data</th>
              <td>{{ formatDateTime(selected.created) }}</td>
            </tr>
            <tr>
              <th class="text-left">Origem</th>
              <td>{{ originLabel(selected.origin) }}</td>
            </tr>
            <tr>
              <th class="text-left">Indicação</th>
              <td>{{ selected.indicacao || "—" }}</td>
            </tr>
            <tr>
              <th class="text-left">Comentário</th>
              <td>{{ selected.comment || "—" }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_details = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    all: null,
    query: "",
    selectedMonth: "",
    menu: false,
    dialog_loading: false,
    dialog_details: false,
    selected: {},
  }),
  computed: {
    // "2026-06" -> "06/2026" (rótulo exibido no campo)
    monthLabel: function () {
      if (!this.selectedMonth) return "";
      const [year, month] = this.selectedMonth.split("-");
      return `${month}/${year}`;
    },
    // filtro local por nome sobre os leads do mês já carregado
    filtered: function () {
      if (!this.all) return [];
      if (!this.query) return this.all;
      const q = this.query.toLowerCase();
      return this.all.filter(function (item) {
        return (item.name || "").toLowerCase().indexOf(q) !== -1;
      });
    },
    // contagem de leads do site (origin = 1) sobre o resultado filtrado
    countSite: function () {
      return this.filtered.filter(function (item) {
        return item.origin == 1;
      }).length;
    },
    // contagem de leads de indicação (origin = 2) sobre o resultado filtrado
    countIndicacao: function () {
      return this.filtered.filter(function (item) {
        return item.origin == 2;
      }).length;
    },
  },
  created: function () {
    const now = new Date();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    this.selectedMonth = `${now.getFullYear()}-${month}`;
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      me.all = [];
      var token = localStorage.getItem("token");
      var period = me.selectedMonth.replace("-", ""); // "2026-06" -> "202606"
      me.dialog_loading = true;
      api
        .get("/lead/month/" + period, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.all = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registros!");
          console.log(error);
        });
    },
    onMonthSelected: function () {
      this.menu = false;
      this.load();
    },
    details: function (item) {
      this.selected = item;
      this.dialog_details = true;
    },
    originLabel: function (origin) {
      if (origin == null) return "—";
      const labels = { 1: "Site", 2: "Indicação" };
      return labels[origin] || "Origem " + origin;
    },
    formatDate: function (date) {
      if (!date) return null;
      date = date.substring(0, date.indexOf("T"));
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateTime: function (value) {
      if (!value) return "—";
      const [date, time] = value.split("T");
      const [year, month, day] = date.split("-");
      const formatted = `${day}/${month}/${year}`;
      return time ? `${formatted} ${time.substring(0, 5)}` : formatted;
    },
  },
};
</script>
